export function AiReceivingPill() {
  return (
    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">
      <span aria-hidden="true">✨</span>
      AI receiving
    </span>
  );
}
